import { WebSpeechPonyfill } from 'botframework-webchat-api';

import useWebChatUIContext from '/druid/internal/useWebChatUIContext';

export default function useWebSpeechPonyfill(): [WebSpeechPonyfill] {
  return [useWebChatUIContext().webSpeechPonyfill];
}
